import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { CODIGO_CENTRUS } from '../../../../app.constants';
import { ConsultaExtratoPreviModel } from '../../../shared/models/consulta-extrato-previ.model';
import { PessoaDadosSimplicadosModel } from '../../../shared/models/pessoa-simplificada.model';
import { FPCReservaPreviPdf } from '../../../shared/services/documentos-pdf-imprimir/Plano/fpc/fpc-reserva-previ-pdf';
import { PessoaService } from '../../../shared/services/pessoa.service';
import { DateUtilService } from '../../../shared/util/date-util.service';
import { StorafeUtil } from '../../../shared/util/storasge.util';
import { FpcService } from '../service/fpc.service';
import { AuthInterceptor } from '../../../interceptor/auth.interceptor';
import { MessageUtil } from '../../../shared/messages/messageUtil';

@Component({
  selector: 'app-fpc-extrato-previ',
  templateUrl: './fpc-extrato-previ.component.html',
  styleUrls: ['./fpc-extrato-previ.component.css']
})
export class FpcExtratoPreviComponent implements OnInit {

  componentes: any[] = [1];

  @BlockUI() blockUi: NgBlockUI;

  consultaExtratoPreviModel: Array<ConsultaExtratoPreviModel> = new Array<ConsultaExtratoPreviModel>();

  pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel = new PessoaDadosSimplicadosModel();

  // 23329	7462800	NEWTON LUIZ DE ATAIDE TRINDADE

  cdCentrus: number;
  cdCentrusTit: number;

  param: string;



  constructor(
    private fpcService: FpcService,
    private pessoaService: PessoaService,
    private fPCReservaPreviPdf: FPCReservaPreviPdf,
    private router: Router,
    private authInterceptor: AuthInterceptor,
    private toastrService: ToastrService,
    private dateUtilService: DateUtilService
  ) { }

  ngOnInit() {

    this._gerenciarCodigoIndentificao();

  }


   getDadosSesseionStorage(): Promise<string> {

    return new Promise((resolve, reject) => {
      const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
      resolve(recuperandoObjeto);
    })


  }

  private async _gerenciarCodigoIndentificao(): Promise<void> {
    await this.getDadosSesseionStorage()
      .then(recuperandoObjeto => {

        if (recuperandoObjeto) {
          const novoObjeto = Number(JSON.parse(recuperandoObjeto));
          this.cdCentrus = novoObjeto
          this.param = '/administrativo/operacoesConsultaParticipante';
        } else {
          this.cdCentrus = this.authInterceptor.getJwtCdCentrus();
          this.param =  '/cardMenus/cardMenuPlanos';
        }
        this.getPessoasDadosSimplificado();
      })
  }



  async getPessoasDadosSimplificado() {
    try {
      this.pessoaDadosSimplicadosModel = await this.pessoaService.getPessoas(this.cdCentrus);
      this.getConsultaExtratoPrevi();
    } catch (error) {
       this.router.navigate([this.param], { skipLocationChange: true })
        this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 });
    }
  }


  async getConsultaExtratoPrevi() {

    try {
      const consultaExtratoPreviList = Object.values(await this.fpcService.getConsultaExtratoPrevi(this.cdCentrus));



      this.consultaExtratoPreviModel = new Array<ConsultaExtratoPreviModel>();
      for (const item of consultaExtratoPreviList) {
        const consultaExtrat: ConsultaExtratoPreviModel = new ConsultaExtratoPreviModel();



        if (Number(item.dtRef.substr(0, 2)) === 1 && Number(item.dtRef.split('/')[1]) === 1998) {
          consultaExtrat.dtRef = this.dateUtilService._formatData(item.dtRef);
        } else if (item.cdHistorico === '210') {
          consultaExtrat.dtRef = '06/09/1996'
        } else {
          consultaExtrat.dtRef = item.dtRef;
        }
        consultaExtrat.sgHistorico = item.sgHistorico;
        if (item.cdHistorico !== '210') {
          consultaExtrat.vlLancto = item.vlLancto
        }
        consultaExtrat.vlSaldo = item.vlSaldo;

        this.consultaExtratoPreviModel.push(consultaExtrat)
      }

    } catch (error) {
       this.router.navigate([this.param], { skipLocationChange: true })
        this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 });
    }
  }


  imprimirPagina() {
    this.fPCReservaPreviPdf.funcionarios(
      this.pessoaDadosSimplicadosModel,
      this.consultaExtratoPreviModel);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/planos/fpc/fpc-extrato-previ/fpc-extrato-previ.component.ts